export default {
  importanceTitle: {
    id: 'comparison_tool_modal_details_title_importance',
    defaultMessage: 'Why it’s important',
  },
} as const
